import { Verification } from "@/types/verification";
import { i18n } from "@/utils/i18n";
import { Box, Button, Popover, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";

interface Props {
    verifications: Verification[];
    setDateRange: React.Dispatch<React.SetStateAction<{ startDate?: Date; endDate?: Date }>>;
    dateRange: { startDate?: Date; endDate?: Date };
}

const Filters: React.FC<Props> = ({ verifications, dateRange, setDateRange }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const isFilterActive = Boolean(dateRange.startDate || dateRange.endDate);

    const earliestTransactionDate = verifications.length
        ? new Date(verifications[0].transaction.date)
        : undefined;
    const lastTransactionDate = verifications.length
        ? new Date(verifications[verifications.length - 1].transaction.date)
        : undefined;

    return (
        <React.Fragment>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
                {i18n.t("verificationList")}
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
                <Button
                    variant={isFilterActive ? "contained" : "outlined"}
                    color={isFilterActive ? "primary" : "primary"}
                    onClick={e => setAnchorEl(e.currentTarget)}
                >
                    {i18n.t("selectDateRange")}
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    disabled={!isFilterActive}
                    onClick={() => setDateRange({ startDate: undefined, endDate: undefined })}
                >
                    {i18n.t("clearFilter")}
                </Button>
            </Box>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                    <DatePicker
                        label={i18n.t("startDate")}
                        value={dateRange.startDate ?? earliestTransactionDate}
                        onChange={(date: Date | null) =>
                            setDateRange(prev => ({
                                ...prev,
                                startDate: date || undefined,
                            }))
                        }
                    />
                    <DatePicker
                        label={i18n.t("endDate")}
                        value={dateRange.endDate ?? lastTransactionDate}
                        onChange={(date: Date | null) =>
                            setDateRange(prev => ({
                                ...prev,
                                endDate: date || undefined,
                            }))
                        }
                    />
                </Box>
            </Popover>
        </React.Fragment>
    );
};

export default Filters;
